import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/language-context";
import { ScrollToTop } from "@/components/layout/scroll-to-top";
import {
  HomePage,
  PolicyPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  CommunityStandardsPage,
  BlueberrySenseiPage,
  DownloadRedirectPage,
  CampaignPage,
  CampaignPostSocialPage,
  UpdatesPage,
  ContactPage,
  CenterPage,
} from "@/components/pages";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/policy/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/policy/terms" element={<TermsOfServicePage />} />
          <Route path="/policy/community-standards" element={<CommunityStandardsPage />} />
          <Route path="/blueberry-sensei" element={<BlueberrySenseiPage />} />
          <Route path="/download" element={<DownloadRedirectPage />} />
          <Route path="/campaign" element={<CampaignPage />} />
          <Route path="/campaigns/post-social-and-earn-bluebreads" element={<CampaignPostSocialPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/center" element={<CenterPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
